import { useContext } from 'react';
import get from 'lodash/get';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { MatureContext } from '../../../Context/MatureContext';
import { SessionContext } from '../../../Context/SessionContext';
import { MobileContext } from '../../../Context/MobileContext';
function getIsEditable(deviation, isMobile) {
    var deviationType = getDeviationType(deviation);
    var canUserEdit = get(deviation, 'extended.canUserEdit', false);
    switch (deviationType) {
        case DeviationTypes.LITERATURE:
        case DeviationTypes.JOURNAL:
            // on mobile, draftjs based lit/journal is not editable
            if (isMobile && get(deviation, 'textContent.html.type') === 'draft') {
                return false;
            }
            return canUserEdit;
        default:
            return canUserEdit;
    }
}
export function useDeviationAttributes(deviation, isOwner) {
    var showMatureContent = useContext(MatureContext);
    var isMobile = useContext(MobileContext);
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    var deviationType = getDeviationType(deviation);
    var isSimple = [
        DeviationTypes.COMMISSION,
        DeviationTypes.STATUS,
        DeviationTypes.POLL,
    ].includes(deviationType);
    var isText = isSimple ||
        [DeviationTypes.JOURNAL, DeviationTypes.LITERATURE].includes(deviationType);
    return {
        hasFlag: !!deviation.dailyDeviation,
        isLoveable: false,
        isCommentable: deviation.isCommentable,
        isFavouritable: !isSimple && !isOwner,
        isGroupSubmittable: isLoggedIn && !isSimple,
        isDownloadable: deviation.isDownloadable,
        isPurchasable: deviation.isPurchasable,
        isShareable: deviation.isShareable || isSimple,
        isReportable: !isOwner,
        isPrintPurchasable: !!deviation.printId &&
            (!deviation.isMature || showMatureContent) &&
            !isText,
        isEditable: getIsEditable(deviation, isMobile),
        isDeletable: isOwner,
    };
}
//# sourceMappingURL=useDeviationAttributes.js.map